<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';
</script>

<template>
  <div class="text-lg md:text-xl text-center lead text-muted py-5">
    <FaIcon
      class="text-blue-500 mr-2"
      name="spinner-third"
      variant="duotone"
      spin
      size="lg"
    />
    <slot />
  </div>
</template>
